var isVisible;
var page = {
	init: function(){
		if(isPage === "top"){
			home.init();
		}else if(isPage === "service"){
			service.init();
		}

		document.addEventListener("visibilitychange", function() {
			if (document.visibilityState === 'visible') {
				console.log(document.visibilityState);
				setTimeout(function(){
					page.returnVisible();
				}, 100);
				if(!isVisible){
					isVisible = true;
				}
			} else {
				isVisible = false;
			}
		});
		var resizeFlag;
		var resizeTimer = null;
		/* window resize
		----------------------------- */
		var resizeCallback = function() {
			page.resize();
			resizeTimer = null;
		};

		$(window).off("resize").on("resize",function(){
			if(resizeTimer) {
				clearTimeout(resizeTimer);
			}
			resizeTimer = setTimeout(resizeCallback, 300);
		});
	},
	resize: function(){
		if(isPage === "top"){
			home.resize();
		}else if(isPage === "service"){
			service.resize();
		}
	},
	returnVisible: function(){
		$("video").each(function(){
			let $this = $(this);
			let mid = $this.attr("id");
			if( mid === "main_movie_pc" || mid === "main_movie_sp" ){

			}else{
				$this[0].play();
			}
		});
	}
}
document.addEventListener('DOMContentLoaded', function () {
	isPage = $("body").attr("id");
	page.init();
});